<template>
  <div class="Background">

    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        cdn-0cn0mkf3
      </h2>

      <div class="link_location">
        {{ $store.getters.t('설정') }} <v-icon small class="mdi mdi-chevron-right" />
        {{ $store.getters.t('시스템 설정') }} <v-icon small class="mdi mdi-chevron-right" />
        {{ $store.getters.t('CDN 등록') }} <v-icon small class="mdi mdi-chevron-right" />
        <a href="/cdn">cdn-0cn0mkf3</a>
      </div>

    </div>


    <v-row>
      <v-col cols="12">
        <h3 class="table_title">
          {{ $store.getters.t('Basic Configuration') }}
        </h3>
        <v-simple-table>
          <template>
              <thead>
                  <tr>
                    <th class="thead_custom_left thead_custom_top pa-3">
                      {{ $store.getters.t('Acceleration region') }}
                    </th>
                    <th class="thead_custom_right thead_custom_top pa-3">
                      <span></span>
                    </th>
                  </tr>
                  <tr>
                    <th class="thead_custom_left pa-3" style="width: 210px">
                      {{ $store.getters.t('Acceleration domain name') }}
                    </th>
                    <th class="thead_custom_right pa-3">
                      <span></span>
                    </th>
                  </tr>
                  <tr>
                    <th class="thead_custom_left pa-3">
                      {{ $store.getters.t('CNAME') }}
                    </th>
                    <th class="thead_custom_right pa-3">
                      <span></span>
                    </th>
                  </tr>
                  <tr>
                      <th class="thead_custom_left pa-3">
                        {{ $store.getters.t('Creation time') }}
                      </th>
                      <th class="thead_custom_right pa-3">
                        <span></span>
                      </th>
                  </tr>
                  <tr>
                    <th class="thead_custom_left pa-3">
                        {{ $store.getters.t('Acceleration type') }}
                    </th>
                    <th class="thead_custom_right pa-3">
                      
                    </th>
                  </tr>
              </thead>
          </template>
      </v-simple-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" class="pl-0">
        <h3 class="cont_title">
          {{ $store.getters.t('Origin Server') }}
        </h3>
        <v-data-table
        :headers="cdnHeaders"
        :items="origins"
        :items-per-page="10"
        :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }"
        class="data-table"
        :disable-sort="true"
        height="300px"/>
      </v-col>

      <v-col cols="12" sm=6 class="pr-0">

            <div class="cont_title">
              <v-row>
                <v-col>
                  <span style="font-weight: bold;">
                    {{ $store.getters.t('Purge') }}
                  </span>
                </v-col>
                <v-col class="text-right">

                  <IconButton :small="true" height="28px" class="mr-2" icon="mdi-refresh"/>
                  <TextButton :buttonText="$store.getters.t('Create Purge')" small isPrimary @click="openModal"/>

                  <AppDialogLarge :value="modalOpen" @input="modalOpen = $event">
                      <template v-slot:title>
                        {{ $store.getters.t('Create Purge') }}
                      </template>
                      <template v-slot:content>
                        <CdnInvalidation />
                      </template>
                      <template v-slot:actions>
                          <TextButtonBlock :buttonText="$store.getters.t('취소')" @click="modalOpen = false" />
                          <TextButtonBlock :buttonText="$store.getters.t('유효성 검사 생성')" isPrimary @click="createLive" />
                      </template>
                  </AppDialogLarge>

                </v-col>
                </v-row>
            </div>
        
        <v-data-table
        :headers="InvalidationsHeader"
        :items="origins"
        :items-per-page="10"
        :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }"
        class="data-table"
        :disable-sort="true" 
        height="300px"/>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import axios from "axios";
import { mapState } from 'vuex';

const srcName = '[cdn.cdn-info.vue] '

import CdnInvalidation from '@/components/cdn/CdnInvalidation.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import AppDialogLarge from '@/components/app/AppDialogLarge.vue';

export default {
  components: {
    TextButton,
    IconButton,
    AppDialogLarge,
    CdnInvalidation,
    TextButtonBlock,
  },
  data() {
        return {
          cdnHeaders: [
              { text: 'Origin Type', value: 'OriginType' },
              { text: 'Origin-Pull Protocol', value: 'OriginPullProtocol' },
              { text: 'Origin-Pull Address', value: 'OriginAddress' },
              { text: 'Origin Domain', value: 'ServerName' },
              { text: 'Port', value: 'Port' },
          ],
          InvalidationsHeader: [
            { text: 'Purge Records', value: 'Url' },
            { text: 'Status', value: 'Status' },
            { text: 'PurgeType', value: 'PurgeType' },
            { text: 'Date created', value: 'CreateTime' },
            ],
          modalOpen: false,
        }
    },
    methods: {
      openModal() {
          this.modalOpen = true;
        },
    }
}
</script>

<style>

</style>